// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"38d95697","578":"64b057a4","703":"f2c60403"}[chunkId] + ".chunk.js";
};